// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import {
  IncompleteStepsDefinition,
  StepDetails,
  StepsDefinition,
} from "./TestRunConstants";

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default (allSteps: IncompleteStepsDefinition): StepsDefinition => {
  const ResultSteps: StepsDefinition = {};

  // Populate the name field
  Object.getOwnPropertyNames(allSteps).forEach((stepName: string) => {
    ResultSteps[stepName] = {
      ...allSteps[stepName],
      name: stepName,
    } as StepDetails;
  });

  const stepIds = Object.keys(ResultSteps);

  function duplicateStepWithSuffix(
    step: StepDetails,
    stepId: string,
    suffix: string,
    parentStepId: string
  ) {
    const newStep = { ...step };
    newStep.nav = { ...newStep.nav };

    if (newStep.nav.previous) {
      newStep.nav.previous = parentStepId;
      newStep.nav.previous += suffix;
    }
    if (newStep.nav.next) {
      newStep.nav.next = { ...newStep.nav.next };
      const nextNav = newStep.nav.next;
      for (const navType in nextNav) {
        nextNav[navType] += suffix;
      }
    }
    const newStepName = stepId + suffix;
    ResultSteps[newStepName] = newStep;
    stepIds.push(newStepName);
  }

  function duplicatePathForSuffix(
    stepId: string | undefined,
    suffix: string,
    parentStepId: string
  ) {
    while (stepId) {
      const step = ResultSteps[stepId];
      duplicateStepWithSuffix(step, stepId, suffix, parentStepId);
      parentStepId = stepId;
      stepId = step.nav?.next?.default;
    }
  }

  for (let i = 0; i < stepIds.length; i++) {
    const stepId = stepIds[i];
    const step = ResultSteps[stepId];
    const nextNav = step.nav.next;
    if (nextNav) {
      const nextNavTypes = Object.keys(nextNav);
      if (nextNavTypes.length > 1) {
        nextNavTypes.forEach((navType: string) => {
          if (navType !== "default") {
            const suffix = capitalizeFirstLetter(navType);
            duplicatePathForSuffix(nextNav[navType], suffix, stepId);
            // step.nav.next.withoutSymptoms = "waitStripReaction"
            // ->  step.nav.next.withoutSymptoms = "waitStripReactionWithoutSymptoms"
            nextNav[navType] += suffix;
            ResultSteps[nextNav[navType]].nav.previous = stepId;
          } else {
            if (ResultSteps[nextNav["default"]]) {
              ResultSteps[nextNav["default"]].nav.previous = stepId;
            }
          }
        });
      }
    }
  }
  return ResultSteps;
};
